import { IComponentOptions } from "angular";
import { SingleMachineMoveComponentController } from "./controller";

export const vsComponentName = "machineMove";
export const singleMachineMoveComponentOptions: IComponentOptions = {
  controller: SingleMachineMoveComponentController,
  controllerAs: "singleMachineMoveComponentController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    machine: "<",
  },
};
